<template>
  <div>
    <!---弹窗相关----->
    <el-dialog top="calc(50vh - 300px)" :close-on-click-modal=false :close-on-press-escape=false
      :modal-append-to-body=true :show-close=false class="priceDialog" width="850px"
      :visible.sync="priceListDialogVisible" append-to-body>
      <template #title>
        <el-row>
          <el-col :span="19" :offset="1">
            <h3 style="text-align: left;">解锁更多权益</h3>
          </el-col>
          <el-col :span="4">
            <el-link v-if="close" :underline="false" style="position: absolute;right: 16px;top: 22px;width: 33px;"
              @click="closeDialog">
              <img src="../assets/imgs/payCloseBtn.png" alt="关闭" style="width:100%" />
            </el-link>

          </el-col>
        </el-row>
      </template>

      <el-row :gutter="20">
        <el-col :span="6">
          <div class="white_container price_vip_row_container">
            <div class="radio_title">专属权益</div>
            <div>
              <img v-if="lever === 'SILVER'" style="width:100%" alt="" src="../assets/imgs/silver_title.png" />
              <img v-if="lever === 'GOLD'" style="width:100%;" alt="" src="../assets/imgs/gold_title.png">
              <br>
              <br>
              <el-row v-if="lever === 'GOLD'">
                <el-col :span="2">
                  <div class="price_have_check"></div>
                </el-col>
                <el-col :span="22" class="price_list_container">
                  <b class="title">弈chat</b>
                  <div class="desc">AI问答，畅聊财经</div>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="2">
                  <div class="price_have_check"></div>
                </el-col>
                <el-col :span="22" class="price_list_container">
                  <b>写作场景</b>
                  <div class="desc">资讯写作、文章导入</div>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="2">
                  <div class="price_have_check"></div>
                </el-col>
                <el-col :span="22" class="price_list_container">
                  <b>文章管理</b>
                  <div class="desc">保存并管理我的文章</div>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="2">
                  <div class="price_have_check"></div>
                </el-col>
                <el-col :span="22" class="price_list_container">
                  <b>素材推荐</b>
                  <div class="desc">AI匹配参考文章、专有名词知识库</div>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="2">
                  <div class="price_have_check"></div>
                </el-col>
                <el-col :span="22" class="price_list_container">
                  <b>便捷组稿</b>
                  <div class="desc">参考文章智能拆解，初<br>稿快速增删改</div>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="2">
                  <div class="price_have_check"></div>
                </el-col>
                <el-col :span="22" class="price_list_container">
                  <b>AI工具包</b>
                  <div class="desc">近义词替换、原创检测、事件图谱等</div>
                </el-col>
              </el-row>
              <div style="clear: both;height: 10px;"></div>
              <div v-if="lever === 'SILVER'" style="clear: both;height: 20px;"></div>
              <el-row v-if="close" style="text-align: center;">
                <el-link href="/price.html" :underline="false">
                  <span style="font-size: 12px!important;">
                    查看版本对比>
                  </span>
                </el-link>
              </el-row>
            </div>

          </div>
        </el-col>
        <el-col :span="18">
          <div class="white_container">
            <div class="radio_title">会员类型</div>
            <div>
              <el-radio-group v-model="lever" size="small" class="lever_radio_group" @change="loadPrice">
                <el-radio class="customer_radio lever_silver" label="SILVER" border>白银VIP</el-radio>
                <el-radio class="customer_radio lever_gold" label="GOLD" border>黄金VIP</el-radio>
              </el-radio-group>
            </div>

          </div>
          <br>
          <div class="white_container">
            <div class="radio_title">购买时长</div>
            <div>
              <div v-if="vipInfo.vipLevel === 'SILVER' && this.lever === 'GOLD'" style="padding:  5px 0px;">
                将根据您当前的会员时长自动升级为同等时长的黄金会员，暂不支持自选购买时长
              </div>
              <el-radio-group v-else v-model="month" size="small" class="lever_radio_group" @change="loadPrice">
                <el-radio class="customer_radio " label="1" border>1个月</el-radio>
                <el-radio class="customer_radio " label="3" border>3个月</el-radio>
                <!-- <el-radio class="customer_radio " label="12" border>12个月</el-radio> -->
              </el-radio-group>

            </div>

          </div>
          <br>
          <div v-if="canLoadPrice" class="white_container" style="height: 270px;">
            <div class="radio_title">支付方式</div>
            <el-row>
              <el-col :span="15">
                <div>
                  <el-radio-group v-model="payType" class="lever_radio_group" @change="toPay">
                    <el-radio class="customer_radio " label="wechat" border> <img
                        style="width:80px;top: -3px;position: relative;" alt=""
                        src="../assets/imgs/WePayLogo.png"></el-radio>
                    <el-radio class="customer_radio " label="alipay" border> <img
                        style="width:80px;top: -3px;position: relative;" alt=""
                        src="../assets/imgs/alipay.png"></el-radio>
                  </el-radio-group>
                </div>
                <h2><span style="font-size: 14px;">总计：</span>￥ {{ curPrice && curPrice.salesPrice }}<span
                    style="font-size: 14px;color: #999999;text-decoration: line-through;">￥ {{ curPrice &&
      curPrice.defaultPrice }}
                  </span>
                </h2>

              </el-col>
              <el-col :span="8">
                <qrcode v-if="payType === 'wechat'" :text="qrcodeContent" :logoSrc="wechatLogo" :options="{ size: 100 }"
                  style="width:160px">
                </qrcode>
                <iframe v-if="payType === 'alipay'"
                  style="width: 320px;border: 0px;height: 300px;overflow: hidden;transform-origin: left top; transform: scale(0.6, 0.6)"
                  :src="aliUrl" title="" />
              </el-col>
            </el-row>
          </div>
          <div v-else class="white_container noPrice" style="height: 255px;">
            <div class="desc">{{ reason }}</div>
            <div class="yx_wechat"></div>
          </div>

        </el-col>
      </el-row>
      <div style="clear: both;height: 100px;"></div>
    </el-dialog>
  </div>
</template>

<script>
import Qrcode from 'vue-qr'
import Loading from '../components/js/Loading.vue'
import * as appJs from '../assets/js/app'
export default {
  props: ['show', 'code'],
  name: 'index',
  data: function () {
    return {
      // 套餐相关
      curPrice: {},
      payType: 'wechat',
      curOrderId: '',
      wechatLogo: require('@/assets/imgs/wechatLogo.png'),
      qrcodeContent: '',
      orderTimer: {},
      close: true,
      priceListDialogVisible: true,
      lever: 'SILVER',
      month: '1',
      aliUrl: '',
      vipInfo: {},
      canLoadPrice: false,
      reason: ''
    }
  },

  filters: {
    numFilter (value) {
      let realVal = parseFloat(value).toFixed(2)
      return realVal
    }
  },
  methods: {
    closeDialog () {
      clearInterval(this.orderTimer)
      this.priceListDialogVisible = false
      this.$emit('close')
    },
    loadPrice () {
      this.canLoadPrice = true
      if (this.vipInfo.vipLevel === 'GOLD' && this.lever === 'SILVER') {
        this.canLoadPrice = false
        this.reason = '黄金VIP失效期间，不支持购买白银VIP如您有特殊购买需求，请联系小弈'
        return
      }

      // if (this.vipInfo.vipLevel === 'SILVER' && this.lever === 'GOLD' && this.month * 30 !== this.vipInfo.packageTime) {
      //   this.canLoadPrice = false
      //   this.reason = '白银升级黄金vip仅支持同时长套餐升级，如您有特殊购买需求，请联系小弈'
      //   return
      // }

      this.axios.get(`/webApi/v3/purchase/getByMonthAndType?month=${this.month}&lever=${this.lever}`).then(resp => {
        this.curPrice = resp.data
        this.toPay()
      })
    },
    toPay () {
      let _this = this
      if (!this.curPrice) {
        this.$message({
          showClose: true,
          message: '未上架套餐！',
          type: 'warning'
        })
        return
      }
      this.axios.getWithLoading('/webApi/v3/order/createOrder?productId=' + this.curPrice.id).then(resp => {
        _this.curOrderId = resp.data
        _this.pay()
      })
    },
    // 拿到订单ID 后的支付
    pay () {
      let _this = this
      if (_this.payType === 'wechat') {
        this.axios.get('/webApi/v3/order/orderDetail?orderId=' + _this.curOrderId).then(resp => {
          _this.genCode(resp.data)
        })
      }
      if (_this.payType === 'alipay') {
        this.aliUrl = '/webApi/v3/order/aliSignData?id=' + _this.curOrderId

        // _this.genCode(window.location.protocol + '//' + window.location.host + '/xy/#/aliPay?id=' + _this.curOrderId)
        // this.axios.get('/webApi/v3/order/aliSignData?id=' + _this.curOrderId).then(resp => {
        //   debugger
        // })
      }
    },
    genCode (codeContent) {
      this.qrcodeContent = codeContent
    },

    // 检查订单状态接口
    getOrderStatus () {
      Loading.silentLoading()
      let _this = this
      this.axios.get('/webApi/v3/order/checkOrderStatus?orderId=' + this.curOrderId).then(resp => {
        if (resp.data === 'order.status.pay.waiting') { // 支付中
          return
        }
        if (resp.data === 'order.status.pay.done') { // 支付成功
          _this.$message({
            message: '恭喜你，支付成功',
            type: 'success'
          });
        }
        if (resp.data === 'order.status.pay.fail') { // 支付失败
          _this.$message.error('支付失败，请稍后重试');
        }
        clearInterval(_this.orderTimer)
        setTimeout(() => {
          if (window.parent) {
            window.open(window.parent.location.href, '_top')
          }
          window.location.reload()
        }, 2000);
      })
    }
  },
  components: {
    qrcode: Qrcode
  },
  mounted () {
    if (this.$route.query.lever) {
      this.lever = this.$route.query.lever
    }
    if (this.$route.query.month) {
      this.month = this.$route.query.month
    }
    if (this.$route.query.close) {
      this.close = false
    }
    if (this.show === 0) {
      this.priceListDialogVisible = false
    } else {
      this.priceListDialogVisible = true
    }
    if (this.code === 3002 || this.code === 3004) {
      this.lever = 'GOLD'
    }
    if (this.code === 3003) {
      this.lever = 'SILVER'
    }
    let _this = this
    appJs.getVip().then(val => {
      _this.vipInfo = val
      this.loadPrice()
    })
  },
  computed: {

  },
  watch: {
    curOrderId: function () {
      let _this = this
      if (this.orderTimer) { // 只要变动都先清理计时器
        clearInterval(this.orderTimer)
        this.orderTimer = null
      }
      if (this.curOrderId) { // 如果存在订单，则开始查询订单
        this.orderTimer = setInterval(function () {
          _this.getOrderStatus()
        }, 3000)
      }
    },
    show: function (newV, oldV) {
      if (newV) {
        this.priceListDialogVisible = true
      }
    }
  }
}
</script>

<style lang="less">
@import '../assets/css/index.less';

.priceDialog {
  .el-dialog__header {
    padding: 0px !important;
  }

  .el-dialog__body {
    padding-top: 0px;
  }

  .el-dialog {
    overflow: hidden;
    border-radius: 10px;
    margin-bottom: 0 !important;
    height: 600px;
    background-color: #FAFAFA;
  }
}
</style>

<style lang="less" scoped>
@import '../assets/css/index.less';

.noPrice {
  .desc {
    width: 300px;
    text-align: center;
    margin: auto;
    font-size: 12px;

  }

  .yx_wechat {
    width: 150px;
    height: 150px;
    background-image: url("../assets/imgs/yx_wechat.png");
    background-size: 100%;
    margin: auto;
  }
}

.price_have_check {
  position: relative;
  top: 2px;
  width: 14px;
  height: 14px;
  background-size: contain;
  margin-right: 3px;
  background-image: url("../assets/imgs/支付页按钮-选中.png");
}

.price_list_container {
  padding-left: 10px;
  margin-bottom: 10px;
}

.price_vip_row_container {
  height: 490px;
  font-size: 12px;

  .title {}

  .desc {
    padding-bottom: 3px;
    font-size: 12px;
    margin-bottom: 5px;
    color: #999;
  }
}

.white_container {
  background-color: white;
  padding: 15px;
  text-align: left;

  .radio_title {
    padding: 10px 00px;
    font-size: 14px;
    padding-top: 0px;
  }
}

.price_rate {
  position: absolute;
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
  background-color: #ff7f7f;
  color: white;
  padding-top: 35px;
  width: 70px;
  font-size: 0.5em;
  top: -22px;
  right: -33px;
  height: 18px;
}

.price_title {
  margin-top: 20px;
  margin-bottom: 15px;
  font-size: 1.2em;
}

.price_total {
  margin-top: 15px;
  margin-bottom: 15px;
}

.price_avg {
  margin-top: 15px;
  margin-bottom: 30px;
}

.price_origin {
  text-decoration: line-through;
  margin-top: 15px;
  margin-bottom: 30px;
}

.imgCaptcha {
  width: 100px;
}

.qrcodeContainer {
  text-align: center !important;
}

.accountAvatar {
  top: 10px;
  position: relative;
}

.avatar-uploader {
  text-align: center !important;
}
</style>

<style lang="less">
.priceDialog {
  .el-radio__label {
    color: black !important;
    padding: 20px;
  }

  .el-radio {
    // margin-right: 20px;
  }

  .is-checked {
    position: relative;

  }

  .is-checked::after {
    content: "✔";
    display: inline-block;
    color: white;
    width: 0;
    height: 0;
    font-size: 12px;
    border: 12px solid #0000;
    border-right: 12px solid #4B8CF7;
    border-bottom: 12px solid #4B8CF7;
    position: absolute;
    right: 0;
    bottom: 0;
  }

  .lever_silver.is-checked {
    border-color: #B7B7B7;
  }

  .lever_silver.is-checked::after {

    border: 12px solid #0000;
    border-right: 12px solid #B7B7B7;
    border-bottom: 12px solid #B7B7B7;

  }

  .lever_gold.is-checked {
    border-color: #E2CA9C;
  }

  .lever_gold.is-checked::after {
    content: "✔";
    display: inline-block;
    color: white;
    width: 0;
    height: 0;
    font-size: 12px;
    border: 12px solid #0000;
    border-right: 12px solid #E2CA9C;
    border-bottom: 12px solid #E2CA9C;
    position: absolute;
    right: 0;
    bottom: 0;
  }

  .customer_radio {
    .el-radio__input {
      display: none;
    }
  }
}

.price_package_container {
  padding: 0px 10px !important;
  height: auto !important;
  overflow: hidden;
  width: 125px !important;
  margin-right: 25px;
}

.price_package_container .el-radio__input {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/app/price.vue